var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChronicConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49392 25.2496V21.1481C8.58932 20.3101 7.95844 19.2188 7.68368 18.0166C7.40891 16.8144 7.50303 15.5574 7.95375 14.4096C8.40445 13.2619 9.19081 12.2766 10.2101 11.5826C11.2294 10.8886 12.4343 10.5181 13.6674 10.5195C18.3411 10.5195 19.35 14.3677 21.0161 18.6898C21.0446 18.7642 21.0547 18.8444 21.0453 18.9236C21.036 19.0028 21.0076 19.0784 20.9625 19.1441C20.9174 19.2099 20.8569 19.2636 20.7865 19.3007C20.716 19.338 20.6375 19.3575 20.5578 19.3576H19.314V21.3216C19.314 21.8425 19.1071 22.342 18.7387 22.7104C18.3704 23.0787 17.8709 23.2856 17.3499 23.2856H16.368V25.2496",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7411 3.25L15.9127 5.83973H17.9368L17.0857 8.15835",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8571 6.06641L21.4904 7.40511L22.9764 8.77954L20.7772 9.90379",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7749 3.2793L9.92957 5.9939L11.8193 5.26853L11.8556 7.73815",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41418 6.70703L4.84862 9.01688L6.16108 7.47589L7.37439 9.62722",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChronicConditions);
export default __webpack_public_path__ + "static/media/chronic_conditions.0584f9e49ca35c68a79da67b88c82bc1.svg";
export { ForwardRef as ReactComponent };